import { ManagePlaceholder } from "./ManagePages.js";

export function PhoneCalls() {
	return (
		<ManagePlaceholder
			title="Calls"
			detail="Call history and live calls are not in the control panel yet."
		/>
	);
}

export function PhoneSms() {
	return (
		<ManagePlaceholder
			title="SMS"
			detail="SMS messaging is not in the control panel yet."
		/>
	);
}
